import { IconButton } from 'components/IconButton/IconButton'
import { State } from 'stores/Workflows/State'
import { ReactComponent as BinIcon } from 'assets/icons/bin.svg'
import Styles from './WorkflowBuilderItem.module.scss'

interface Props {
  state: State
}

export const DeleteButton = ({ state }: Props) => {
  return (
    <IconButton
      title={`Delete status ${state.value}`}
      variant="tertiary"
      icon={BinIcon}
      onPress={() => state.destroy()}
      className={Styles.deleteButton}
    />
  )
}
